<div class="org-aliases" *ngIf="platforms.length || names.length">
    <div class="seen-on" *ngIf="platforms.length">
        <span class="seen-on-label">{{ 'seenon' | translate }}</span>
        <span class="platform-chip" *ngFor="let p of platforms">{{ p }}</span>
    </div>

    <button *ngIf="names.length" type="button" class="known-as-toggle" (click)="expanded = !expanded">
        <nb-icon [icon]="expanded ? 'chevron-down-outline' : 'chevron-right-outline'"></nb-icon>
        {{ 'knownas' | translate }} ({{ names.length }})
    </button>

    <ul class="known-as" *ngIf="expanded">
        <li *ngFor="let n of names">{{ n }}</li>
    </ul>
</div>
